import { useState, useEffect } from 'react';

export default function FormatDate({ date }) {
  const [formattedDate, setFormattedDate] = useState('');

  useEffect(() => {
    let parsedDate = new Date(date);
    
    if (isNaN(parsedDate.valueOf())) {
      setFormattedDate('');
      return;
    }

    const timeformat = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour12: false
    };

    setFormattedDate(parsedDate.toLocaleDateString('en-US', timeformat));
  }, [date]);

  // Show loading state during hydration
  if (!formattedDate) {
    return <>Loading date...</>;
  }

  return <>{formattedDate}</>;
}
